module.exports = __webpack_public_path__ + "img/youku@2X.329e4098.png";